/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Backdrop, Typography, IconButton, Tooltip, Button, Dialog, Avatar, CircularProgress, Divider, Tab, TableContainer, Table, TableHead, TableCell, TableRow, TableBody } from '@material-ui/core'
import { ArrowBack , ArrowForward, ThumbUp, ThumbDown, MoodBad, Clear, Block, Label, AssignmentLate } from '@material-ui/icons'

import MaterialTable from "material-table";

import Action from '../../fluid/Actions/ActionFactory' 
import table_icons from "../tableIcons";

const clone = require('rfdc')()

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({

})

class SampleAnnotation extends Component {
    state = {
        open : true,
        pairs_loading : false,
        pairs : null,
        pairs_error : false,
        loading_pair : false,
        loading_pair_error : false,
        cur_pairs : null,
        cur_pair_data : [],
        cur_pair_user_input : null,
        cur_pair_check_status : null,
        columns : [],
        setting_pairs : false,
        check_status : false,
        n_match : null,
        n_distinct : null,
        setting_pair : false,
        user_input : null,
        min_samples_per_class : null,
        error_finish : false
    }

    componentDidMount () {
        this.getPair()
    }

    getPair = () => {
        this.setState({...this.state, loading_pair : true, user_input : null}, () => {
            Action("http_request", {
                url : "/sainapse/duplicate_detection/annotation_samples",
                method : "GET",
                params : {
                    ic_name : this.props.ic.name,
                    operation : this.props.op
                }
            }).then(res => {
                let result_json = JSON.parse(res.data.result)
                let result = result_json.Result
                console.log("Pair Data : ", result)
                this.setState({
                    ...this.state, 
                    cur_pairs : result.record_pairs, 
                    n_match : result.n_match, 
                    n_distinct : result.n_distinct, 
                    loading_pair : false,
                    min_samples_per_class : result.min_samples_per_class,
                }, () => this.setState({
                    ...this.state, 
                    //cur_pairs_data : this.getRecordPairs(), 
                    columns : this.getRecordColumns()}, 
                    () => console.log("Pair Data State : ", this.state)))
            })
        })
    }

    // setPair = async () => {
    //     this.setState({...this.state, setting_pair : true}, async () => {
    //         try {
    //             let pair_data = await Action('http_request', {
    //                 url : "/sainapse/duplicate_detection/annotation_samples",
    //                 method : 'post',
    //                 data : this.state.cur_pair,
    //                 params : {
    //                     check_status : false,
    //                     ic_name : this.props.ic.name,
    //                     user_input : this.state.user_input
    //                 }
    //             })

    //             let result = pair_data
    //             console.log("Set Pair Data : ", result)
    //         } catch (err) {
    //             console.log("Set Pair Data Error : ", err)
    //         }
    //     })
    // }

    setPairAndPrevious = () => {
        this.state.cur_pairs.map(pair => pair.user_input = 'previous')
        this.setState({...this.state, setting_pair : true}, () => {
            Action('http_request', {
                url : "/sainapse/duplicate_detection/annotation_samples",
                method : 'post',
                data : {
                    annotated_sets : this.state.cur_pairs,
                    check_status : false,
                    ic_name : this.props.ic.name,
                    operation : this.props.op
                },
                params : {}
            }).then(res => {
                this.getPair()
            })
        })
    }

    setPairAndProceed = () => {
        this.setState({...this.state, setting_pair : true}, () => {
            Action('http_request', {
                url : "/sainapse/duplicate_detection/annotation_samples",
                method : 'post',
                data : {
                    annotated_sets : this.state.cur_pairs,
                    check_status : false,
                    ic_name : this.props.ic.name,
                    operation : this.props.op
                },
                params : {}
            }).then(res => {
                this.getPair()
            })
        })
    }

    setPairAndComplete = () => {
        this.state.cur_pairs.map(pair => pair.user_input = (pair.user_input !== null && pair.user_input !== 'previous')? pair.user_input : 'uncertain')
        this.setState({...this.state, setting_pair : true, error_finish : false}, () => {
            Action('http_request', {
                url : "/sainapse/duplicate_detection/annotation_samples",
                method : 'post',
                data : {
                    annotated_sets : this.state.cur_pairs,
                    check_status : true,
                    ic_name : this.props.ic.name,
                    operation : this.props.op
                },
                params : {}
            }).then(res => {
                if (res.data.result.Result.check_status) {
                    Action('http_request', {
                        url : "/sainapse/duplicate_detection/annotation_samples",
                        method : 'post',
                        data : {
                            annotated_sets : [{record_pair : 'none', user_input : 'finish'}],
                            check_status : true,
                            ic_name : this.props.ic.name,
                            //user_input : 'finish',
                            operation : this.props.op
                        },
                        params : {}
                    }).then(res => {
                        this.props.close()
                    }).catch(err => {
                        this.setState({...this.state, error_finish : true})
                    })
                } else {
                    this.setState({...this.state, error_finish : true})
                }
            })
        })
    }

    cleanUpPairs = () => {
        let clean_pair = clone(this.state.cur_pairs)

        clean_pair.map(pair => {
            pair.record_pair.map((record) => {
                delete record.wv_field_list.tableData
            })
        })

        return clean_pair[0].record_pair
    }

    getRecordColumns = () => {
        let clean_pair = this.cleanUpPairs()
        let columns = Object.keys(clean_pair[0].wv_field_list)
        // .map(field => {
        //     return {
        //         title : field,
        //         field : field
        //     }
        // })
        
        return columns
    }

    getRecordPairs = (record_pair) => {
        let data = record_pair.map(rec => {
            return rec.wv_field_list
        })

        return data
    }

    renderPair = () => {
        if (this.state.cur_pairs !== null) {
            return(
                <div style =  {{width  :'100%', maxHeight : '65vh', overflow : 'auto', display : 'flex', flexDirection : 'row',}}>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {this.state.columns.map((column) => {
                                        return(
                                            <TableCell colspan={1}>{column}</TableCell>
                                        )
                                    })}
                                    <TableCell align='center'>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.cur_pairs.map((record_pair,i) => {
                                    return(
                                        <Fragment>
                                            <TableRow>
                                                {this.state.columns.map((column) => {
                                                    return(
                                                        <TableCell>{record_pair.record_pair[0].wv_field_list[column]}</TableCell>
                                                    )
                                                })}
                                                <TableCell rowSpan={2}>{this.renderActions(record_pair,i)}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                {this.state.columns.map((column) => {
                                                    return(
                                                        <TableCell>{record_pair.record_pair[1].wv_field_list[column]}</TableCell>
                                                    )
                                                })}
                                            </TableRow>
                                        </Fragment>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {/* {
                        this.state.cur_pairs.map((pair, index) => {
                            return (
                                <div style={{ display : 'flex', flexDirection : 'column', alignItems : 'center', justifyContent : 'center', width : '100%'}}>
                                    <div style={{width: '100%', display : 'flex', flexDirection: 'row', alignItems : 'center', justifyContent : 'center'}}>
                                        <MaterialTable
                                            style={{ width: "80%" }}
                                            icons={table_icons}
                                            columns={[]}
                                            options={{
                                                search: false,
                                                toolbar : false,
                                                toolbarButtonAlignment: "right",
                                                paging: false,
                                                maxBodyHeight: "40vh",
                                            }}
                                            data = {this.getRecordPairs(pair.record_pair)}
                                        />
                                        <div style={{ width : '20%'}}>{this.renderActions(pair,index)}</div>
                                    </div>
                                </div>
                            )
                        })
                    } */}
                </div>
            )  
        } else {
            if (this.state.loading_pair) {
                return (
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'center'}}>
                        <CircularProgress color ='primary'/>
                    </div>
                )
            }
        }
    }

    setUserInput = (user_input,index) => {
        let new_pairs = this.state.cur_pairs
        new_pairs[index].user_input = user_input
        this.setState({...this.state, cur_pairs : new_pairs})
    }

    renderActions = (pair, index) => {
        if (this.state.cur_pairs.length > 0) {
            let cur_pair = this.state.cur_pair
            let decision = null

            return (
                <div style = {{width : '100%', display : 'flex', flexDirection  : 'row', alignItems : 'center', justifyContent : 'center', margin : '10px'}}>
                    <Tooltip title = "Match">
                        <IconButton 
                            // color = {this.state.user_input === 'match' ? 'primary' : null}
                            onClick = {() => this.setUserInput('match', index)}>
                            <ThumbUp style = {{ color : this.state.cur_pairs[index].user_input === 'match' ? "#2296f3" : null }}/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title = "Distinct" >
                        <IconButton 
                            // color = {this.state.user_input === 'uncertain' ? 'secondary' : null}
                            onClick = {() => this.setUserInput('distinct',index)}>
                            <ThumbDown style = {{ color : this.state.cur_pairs[index].user_input === 'distinct' ? "#dc004e" : null }}/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title = "Uncertain" >
                        <IconButton 
                            // color = {this.state.user_input === 'uncertain' ? 'secondary' : null}
                            onClick = {() => this.setUserInput('uncertain',index)}>
                            <AssignmentLate style = {{ color : this.state.cur_pairs[index].user_input === 'uncertain' ? "#dc004e" : null }}/>
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    }

    checkUserInputs = () => {
        let pair_unmarked = this.state.cur_pairs.find((pair) => pair.user_input === null)
        return pair_unmarked ? false : true
    }

    updatePair = (decision) => {
        let new_pairs = clone(this.state.pairs)
        new_pairs[this.state.cur_pair].decision = decision
        new_pairs[this.state.cur_pair].review = "True"

        this.setState({...this.state, pairs : new_pairs}, console.log("Updated Pair : ", this.state))
    }

    handleClose = () => {
        this.props.close()
    }

    changePair = (direction) => {
        if (direction === 'next') {
            this.setState({...this.state, cur_pair : this.state.cur_pair + 1, cur_pair_data : this.getRecordPairs(this.state.cur_pair + 1)})
        }

        if (direction === 'prev') {
            this.setState({...this.state, cur_pair : this.state.cur_pair - 1, cur_pair_data : this.getRecordPairs(this.state.cur_pair - 1)})
        }
    }

    render() { 
        return (
            <Dialog fullScreen open = {this.props.open}>
                <Paper style = {{width : '100vw', height : '100vh'}}>
                    <div style = {{width : '100%', height : '50px', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <Avatar style = {{backgroundColor : "rgba(255, 103, 1, 1.0)", marginRight : '10px'}}>
                            <Label style = {{color : '#FFFFFF'}}/>
                        </Avatar>
                        <Typography style = {{flexGrow : 1, fontSize : '15px', fontWeight : '500'}} variant = 'h6'>{"Annotate Samples for Model " + this.props.ic.name}</Typography>
                        {this.state.error_finish && <Typography variant = 'caption' color = 'secondary'>Error in completing the operation.</Typography>}
                        <Button style = {{margin: '5px'}} variant = 'contained' color = 'primary' onClick = {() => this.props.close()}>Close</Button>
                        <Button style = {{margin: '5px'}} variant = 'contained' color = 'primary' onClick = {() => this.setPairAndComplete()}>Complete</Button>
                        {/* <IconButton onClick = {this.handleClose}>
                            <Clear/>
                        </IconButton> */}
                    </div>
                    <div 
                        style = {{
                            backgroundColor : '#F0F0F0', 
                            width : '100%', 
                            height : 'calc(100vh - 100px)', 
                            display : 'flex', 
                            flexDirection : 'column', 
                            borderTop : '1px solid rgba(0,0,0,0.12)', 
                            borderBottom : '1px solid rgba(0,0,0,0.12)'
                        }}>
                        <div style = {{width : '100%', padding : '20px'}}>
                            <Paper style = {{width : '50%', height : '100%', padding : '10px'}}>
                                <Typography variant = 'button'>Summary</Typography>
                                <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                                <div style = {{display : 'flex', flexDirection : 'row', alignContent : 'center', padding : '5px'}}>
                                    <Typography variant = 'body2'>Number of Matched Records : </Typography><Typography style = {{flexGrow : 1}} align = 'right' variant = 'subtitle2' color = 'primary'>{Number(this.state.n_match) + '/' + this.state.min_samples_per_class}</Typography>
                                </div>
                                <div style = {{display : 'flex', flexDirection : 'row', alignContent : 'center', padding : '5px'}}>
                                    <Typography variant = 'body2'>Number of Distinct Records : </Typography><Typography style = {{flexGrow : 1}} align = 'right' variant = 'subtitle2' color = 'primary'>{Number(this.state.n_distinct) + '/' + this.state.min_samples_per_class}</Typography>
                                </div>
                            </Paper>
                        </div>
                        <div style = {{width : '100%', height : '80%', padding : '20px', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'center'}}>
                            <div style = {{width  : '100%'}}>
                                {this.state.pairs !== null && this.state.cur_pair_data.length > 0 ? 
                                <div style = {{backgroundColor : '#F0F0F0', width : '100vw', height : '50px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                                    <Typography variant = 'button' color = 'primary'>{"Sample " + (this.state.cur_pair + 1) + "/" + this.state.pairs.length}</Typography>
                                </div> : null}
                                {this.renderPair()}
                                <div style={{ width : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'center'}}>
                                { <Tooltip title = "Previous Sample">
                                    <IconButton 
                                        color = 'primary' 
                                        disabled = {!(this.state.n_match > 0 || this.state.n_distinct > 0)}
                                        //disabled = {this.state.cur_pair !== null ? this.state.cur_pair === 0 ? true : false : true}
                                        onClick = {() => this.setPairAndPrevious()}
                                    >
                                        <ArrowBack/>
                                    </IconButton>
                                </Tooltip>}
                                {(this.state.cur_pairs) && <Tooltip title = "Next Sample">
                                    <IconButton 
                                        color = 'primary' 
                                        disabled = {!this.checkUserInputs()}
                                        //disabled = {this.state.cur_pair !== null ? this.state.cur_pair === this.state.pairs.length - 1 ? true : false : true}
                                        onClick = {() => this.setPairAndProceed()}
                                    >
                                        <ArrowForward/>
                                    </IconButton>
                                </Tooltip>}
                                </div>
                                {/* {this.renderActions()} */}
                            </div>
                        </div>
                    </div>
                </Paper>
            </Dialog>
        );
    }
}

export default withStyles(styles)(SampleAnnotation);